import { createContext } from 'react'

export const GameSoundsContext = createContext(null)